<template>
	<div>
		<v-toolbar color = "blue-grey lighten-5" class = "index-topbar">
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-fine.png" alt = "music x lab logo" class = "logo"/>
			</v-hover>
      <div style="width: 30px"></div>
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-nyu.png" alt = "music x lab logo" class = "logonyu"/>
			</v-hover>
      <div style="width: 30px"></div>
      <v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-mbzuai.png" alt = "mbzuai logo" class = "logombz"/>
			</v-hover>
    		<!-- <v-toolbar-title>Music X Lab</v-toolbar-title> -->
    		<v-spacer></v-spacer>
    		<v-toolbar-items  style="font-family:'Breve Display';">
      			<v-btn flat :color= "this.$color.activate" style="font-size:1.2rem;font-weight:200; " @click =" $router.push({path:'/index'})">Home</v-btn>
      			<v-btn flat :color= "this.$color.primary" style="font-size:1.2rem;" @click =" $router.push({path:'/people'})">People</v-btn>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#575757" flat v-on = "on" style="font-size:1.2rem;" @click =" $router.push({path:'/groups'})">Groups</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, index) in groupInfo" :key = "index" @click="$router.push({name:'Groups',params:{logan:item.logan}})" >
          					<v-list-tile-title>
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
      				</v-list>
				</v-menu>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#657C88" flat v-on = "on" style="font-size:1.2rem;">Demos</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, dindex) in demoInfo" :key = "dindex" @click="$router.push({path: item.address})" >
          					<v-list-tile-title >
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
                        <v-list-tile flat @click="switchToPage('https://www.cs.cmu.edu/~gxia/demo.html')"><v-list-tile-title >Other Demos</v-list-tile-title></v-list-tile>
      				</v-list>
                    
				</v-menu>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" $router.push({path:'/publications'})">Publications</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('http://blog.musicxlab.com/') ">Blog</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('https://github.com/music-x-lab/music-x-lab') ">Github</v-btn>
				<!-- <v-btn flat>News</v-btn> -->
    		</v-toolbar-items>
  		</v-toolbar>
		<v-carousel height = "31.5vw"  class = "index-gallery" :style="{background:'url(' + indexIntro.backgrounds[0] + ')'}">    
			<v-carousel-item v-for="(item,index) in indexIntro.gallery" :key="index" contain>
        		<v-img :src="item"  :aspect-ratio="16/9" contain lazy height = "31.5vw" >
					<template v-slot:placeholder>
						<v-layout fill-height align-center justify-center ma-0>
						<v-progress-circular indeterminate color="purple"></v-progress-circular>
						</v-layout>
					</template>
        		</v-img>
			</v-carousel-item>
		</v-carousel>
		<v-container grid-list-md text-xs-center>
			<v-layout row wrap class = "mb-4" >
				<v-flex xs2></v-flex>
				<v-flex xs8>
					<div class = "display-3 text-xs-center mb-2" :style="{fontFamily:'Breve Display ' + '!important', color:$color.primary,fontWeight:200}">{{indexIntro.title[0]}}</div>
					<div class = "display-1 text-xs-center mb-2" :style="{fontFamily:'BenMo ' + '!important', color:$color.primary,fontWeight:400}">{{indexIntro.title[1]}}</div>
					<v-divider class = "mb-2"></v-divider>
					<div class = "text-xs-left headline font-weight-regular mb-4" :style="{ color:$color.primary}">
						<transition-group name="fade">
						<div v-for="(ins,c_id) in indexIntro.intro" :key="c_id" class = "my-4">
							<div v-for="(subContent,sc_id) in ins" :key="c_id * sc_id"> 
								<div v-if="sc_id == 0" class = "v-btn__content my-3" style="justify-content:left;font-size:2.0rem;font-family:ProximaNova;font-weight:bold">
                                    <v-icon left>my_location</v-icon>
                                    <span>{{ subContent }}</span>
                                </div>
								<p v-else class = "mx-5 text-xs-left" style="font-size:1.5rem;font-family:ProximaNova;" v-html = "subContent"></p>
							</div>
							
							<v-divider class = "mx-5" ></v-divider>
						</div>
						</transition-group>
					</div>
				</v-flex>
				<v-flex xs2></v-flex>
				
			</v-layout>
			<div class = "display-2 text-xs-center mb-4" :style="{fontFamily:'Calluns ' + '!important', color:$color.primary,fontWeight:'bold'}">Teams and Directions</div>
			<v-divider></v-divider>
			<v-layout row wrap class = "mt-4">
				<v-flex v-for="(item,index) in majorGroupInfo" :key="index" xs4>
					<v-hover>
						<v-card slot-scope="{ hover }" class="mx-auto" color="grey lighten-4" >
								<v-img :aspect-ratio="1920/1080" :src="item.introPic" height="320px">
									<transition name="fade">
										<div v-if="hover" class="text-xs-center darken-2 v-card--reveal headline white--text" 
											style="height: 320px;display:flex;align-items: center;flex-direction:column;justify-content:center;background-color:rgba(0,0,0,0.4);padding:1.0rem;">
											<p v-for="(keyword,k_id) in item.description" :key="k_id" class = "text-xs-center" >
												{{keyword}} 	
											</p>
										</div>
									</transition>
									<template v-slot:placeholder>
										<v-layout fill-height align-center justify-center ma-0>
											<v-progress-circular indeterminate :color="item.logan"></v-progress-circular>
										</v-layout>
									</template>
								</v-img>	
								<div style="height:160px;">
								<v-card-text class="pt-4" style="position: relative;" >
									<v-btn absolute :color="item.logan" class="white--text" fab right top @click="$router.push({name:'Groups',params:{logan:item.logan}})">
										<v-icon style="display:flex !important;" >navigation</v-icon>
									</v-btn>
									<div class="mb-2" :style="{fontFamily:'Calluns !important',fontSize:item.name.length > 35 ? '1.9rem':'2.2rem'}" >{{item.name}}</div>
									<div class="mb-2" style="font-family:Lishu !important;font-size:1.9rem;">{{item.intro}}
									</div>
								</v-card-text>
								</div>
						</v-card>
					</v-hover>
				</v-flex>
			</v-layout>
		</v-container>
		<v-footer height="auto" >
			<v-layout justify-center row wrap class = "elevation-2" color="white" >
			<v-flex color="white" py-3 text-xs-center  xs12 >
				<div color="white" class = "subheading"> &copy;2019 — Music-X-Lab | NYU Shanghai 
					 <!-- <a href = "http://www.beian.miit.gov.cn">沪ICP备19034312号-1</a> -->
					 </div>
			</v-flex>
			</v-layout>
		</v-footer>
	</div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
		sscolor:"#575757",
		groupInfo:[{name:"",
					introPic:"",
					intro:"",
					description:"",
					logan:""
					}],
    majorGroupInfo:[{name:"",
					introPic:"",
					intro:"",
					description:"",
					logan:""
					}],
		picUrl:["https://i.postimg.cc/cCmCHWwF/1.jpg","https://i.postimg.cc/yYxs90H1/2.jpg","https://i.postimg.cc/zD0qV042/3.jpg","https://i.postimg.cc/0jBgZHs8/4.png","https://i.postimg.cc/PxHd8ct9/5.jpg"],
		indexIntro:{title:[], intro:[],backgrounds:[''],gallery:[]},
		demoInfo:[
            {name:"Interactive Rainbow Score", address:"/demo/IRS"}
        ]
    }
  },
  mounted() {
	  this.getIndexInfo();
  },
  props: {
    msg: String
  },
  methods: {
	
    getIndexInfo:function() {
		let that = this
		this.$axios.get("/index").then(function(res) {
			that.indexIntro.title = res.data.title
			that.indexIntro.intro = []
			for(let i in res.data.description) {
				that.indexIntro.intro.push(res.data.description[i])
				that.indexIntro.gallery = res.data.gallery
				that.indexIntro.backgrounds = res.data.backgrounds
			}
			console.log(that.indexIntro)
		}).catch(function(error) {
			console.log(error)
		})
		this.$axios.get("/group/id/list").then(function(res) {
			console.log(res)
			that.groupInfo = []
			for(let i in res.data) {
				that.groupInfo.push({
					name:res.data[i].name,
					intro:res.data[i].intro,
					introPic:res.data[i].picture,
					description:res.data[i].keywords,
					logan:res.data[i].color
				})
			}
      that.majorGroupInfo = []
      for (let i = 0; i < 6; ++i) {
				that.majorGroupInfo.push({
					name:res.data[i].name,
					intro:res.data[i].intro,
					introPic:res.data[i].picture,
					description:res.data[i].keywords,
					logan:res.data[i].color
				})
      }
		}).catch(function(error) {
			console.log(error)
		})
	},
    switchToPage:function(url) {
		window.location.href=url
	},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.fade-enter-active,.fade-leave-active {
	transition: opacity 0.5s;
	-webkit-transition: opacity 0.5s;
}
   
.fade-enter,.fade-leave-active{
	opacity: 0;
} 

</style>
